import { useLazyQuery } from '@apollo/client';
import ShoppingListQuery from './ShoppingListQuery';

const ShoppingListOnDemandConnectorApollo = ({ children }) => {
  const [fetchShoppingList, { data, loading, error, called }] = useLazyQuery(ShoppingListQuery);

  const fetchShoppingListOnDemand = (period) => {
    fetchShoppingList({
      variables: { period },
    });
  };

  const result = {
    loadingOnDemand: loading,
    error,
    fetchShoppingListOnDemand,
  };

  if (error) {
    throw error;
  }

  if (
    called &&
    !loading &&
    data.me.shoppingList &&
    data.me.shoppingList.__typename === 'UserShoppingList'
  ) {
    const categories = data.me.shoppingList.category.map((singleCategory) => {
      const newCategory = {
        ...singleCategory,
        products: singleCategory.product,
      };
      delete newCategory.product;

      return newCategory;
    });

    const shoppingList = {
      ...data.me.shoppingList,
      categories,
    };

    delete shoppingList.category;

    result.shoppingList = shoppingList;
    result.availableDays = data.me.diet.availableDays.map((i) => i.date);
    result.period = data.me.shoppingList.period;
  }

  return children(result);
};

export default ShoppingListOnDemandConnectorApollo;
